import AdminNav from './AdminNav/AdminNav';

import NavBar from './NavBar/NavBar';

import RequestModal from './Modal/Modal';
import RiceTypeModal from './Modal/RiceTypeModel'
import Loading from './Loading/Loading';

export {
  AdminNav,
  NavBar,
  RequestModal,
  Loading,
  RiceTypeModal,
}
